/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ClassroomdisciplineSharedChatTypes200,
  GetApiV1ClassroomdisciplineSharedChatTypes401,
  GetApiV1ClassroomdisciplineSharedChatTypesQueryParams,
  GetApiV1ClassroomdisciplineSharedChatTypesQueryResponse,
} from "../../types/classPlanningSharedController/GetApiV1ClassroomdisciplineSharedChatTypes.ts";
import { dropDownListViewModelSchema } from "../dropDownListViewModelSchema.ts";

export const getApiV1ClassroomdisciplineSharedChatTypesQueryParamsSchema =
  z.object({
    culture: z.string().default("pt-BR"),
  }) as unknown as ToZod<GetApiV1ClassroomdisciplineSharedChatTypesQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ClassroomdisciplineSharedChatTypes200Schema = z.array(
  z.lazy(() => dropDownListViewModelSchema),
) as unknown as ToZod<GetApiV1ClassroomdisciplineSharedChatTypes200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ClassroomdisciplineSharedChatTypes401Schema =
  z.any() as unknown as ToZod<GetApiV1ClassroomdisciplineSharedChatTypes401>;

export const getApiV1ClassroomdisciplineSharedChatTypesQueryResponseSchema =
  z.lazy(
    () => getApiV1ClassroomdisciplineSharedChatTypes200Schema,
  ) as unknown as ToZod<GetApiV1ClassroomdisciplineSharedChatTypesQueryResponse>;
